module.exports = __webpack_public_path__ + "static/media/022-jaw.acefd463.svg";